<div class="contract-container">
  <!-- Título y subtítulo -->
  <app-page-header
    [title]="'Mis contratos'"
    [subtitle]="'Visualiza tus boletas'"
  ></app-page-header>

  <!-- Tabs y tabla dinámica -->
  <app-page-container
    [displayedColumns]="displayedColumns"
    [dataSource]="historyContract"
    [serverSidePagination]="true"
    [totalElements]="totalElements"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    [actionButtons]="actionButtons"
    [showPreviewCard]="true"
    [isLoading]="isLoadingHistory"
    [customTemplates]="{
      companyName: companyNameTemplate,
      jobPositionName: jobPositionNameTemplate,
      salary: salaryTemplate,
      startDate: startDateTemplate,
      endDate: endDateTemplate
    }"
    (rowSelected)="onRowSelected($event)"
    (pageChange)="onPageChange($event)"
    [selectedDocument]="selectedDocument"
    [hasCheckbox]="true"
  >
    <ng-template #companyNameTemplate let-row>
      <span class="truncate-text">{{ row.companyName | capitalize }}</span>
    </ng-template>
    <ng-template #jobPositionNameTemplate let-row>
      <span class="truncate-text">{{ row.jobPositionName | capitalize }}</span>
    </ng-template>
    <ng-template #salaryTemplate let-row> S/. {{ row.salary }} </ng-template>
    <ng-template #startDateTemplate let-row>
      {{ formatDate(row.startDate) }}
    </ng-template>
    <ng-template #endDateTemplate let-row>
      {{ formatDate(row.endDate) }}
    </ng-template>
  </app-page-container>

  <div class="contract-validate-modal">
    <app-contract-validate-modal
      [(visible)]="showModalValidate"
      [dataToView]="dataToUpdate"
      (visibleChange)="onDialogValidateClose()"
      (updateStateComplete)="onUpdateStateComplete()"
    >
    </app-contract-validate-modal>
  </div>
</div>
